import React from 'react';
import styled from 'styled-components';
import { Box, IconButton, Text } from '@sparknz/spark-pattern-library';

interface PlanCardQuantitySelectionProps {
  handleDecrease: (offerId: string, planName: string, price?: number) => void;
  handleIncrease: (
    offerId: string,
    planName: string,
    isTeamUpEligible: boolean,
  ) => void;
  planId: string;
  planName: string;
  price?: number;
  planQuantity: number;
  isTeamUpEligible: boolean;
}

const PlanCardQuantitySelectionWrapper = styled(Box)`
  width: 100%;
`;

const PlanCardQuantitySelection = ({
  handleDecrease,
  handleIncrease,
  planId,
  planName,
  price,
  planQuantity,
  isTeamUpEligible,
}: PlanCardQuantitySelectionProps) => {
  return (
    <PlanCardQuantitySelectionWrapper
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <IconButton
        onClick={() => handleDecrease(planId, planName, price)}
        title="decrease"
        icon="minus_small"
      />
      <Text variant="bodyMDemi">{planQuantity}</Text>
      <IconButton
        onClick={() => handleIncrease(planId, planName, isTeamUpEligible)}
        title="increase"
        icon="plus_small"
      />
    </PlanCardQuantitySelectionWrapper>
  );
};

export default PlanCardQuantitySelection;
